import React, { useState, useEffect } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Galeri resimleri
  const images = [
    { id: 1, src: '/images/gallery/3dd0115d-5a00-422c-a47d-712c0c564c38.JPG', alt: 'Buz pateni eğitimi' },
    { id: 2, src: '/images/gallery/4ada0c51-cbd3-44f8-b49e-a8f5d53185b8.JPG', alt: 'Buz pateni eğitimi' },
    { id: 3, src: '/images/gallery/4c28028c-117c-462f-ba51-80442fa3828f.JPG', alt: 'Buz pateni eğitimi' },
    { id: 4, src: '/images/gallery/CC1DC249-AF10-45BF-8A2C-A8F5D97FA9F2.PNG', alt: 'Buz pateni eğitimi' },
    { id: 5, src: '/images/gallery/IMG_2703 (1).jpeg', alt: 'Buz pateni eğitimi' },
    { id: 6, src: '/images/gallery/IMG_4424.WEBP', alt: 'Buz pateni eğitimi' },
    { id: 7, src: '/images/gallery/e41e23b8-bdb9-46aa-809a-5f92f3ef6dfc.JPG', alt: 'Buz pateni eğitimi' },
  ];

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setSelectedIndex(index);
    document.body.style.overflow = 'hidden'; // Scroll'u engelle
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

  const nextImage = () => {
    const nextIndex = (selectedIndex + 1) % images.length;
    setSelectedIndex(nextIndex);
    setSelectedImage(images[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (selectedIndex - 1 + images.length) % images.length;
    setSelectedIndex(prevIndex);
    setSelectedImage(images[prevIndex]);
  };

  // Klavye ile navigasyon
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage) {
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowRight') {
          nextImage();
        } else if (e.key === 'ArrowLeft') {
          prevImage();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, selectedIndex]);

  return (
    <div className="gallery">
      <div className="gallery-container">
        <h1 className="gallery-title">Galeri</h1>
        <p className="gallery-subtitle">Eğitimlerimizden ve anılarımızdan kareler</p>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => openLightbox(image, index)}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/400x300?text=Görsel+Yüklenemedi';
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            ×
          </button>
          <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
            ‹
          </button>
          <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
            ›
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="lightbox-image"
            />
            <div className="lightbox-info">
              <p>{selectedIndex + 1} / {images.length}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;

